import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useAtom } from 'jotai';
import { Flex } from 'components/primitives/flex';
import { Text } from 'components/primitives/typography';
import Checkbox from 'components/ui/Checkbox/Checkbox';
import { searchMapAsMoveAtom } from '../Filter/filterStore';

export default function SearchAsMoveToggle({ onDragEndAction }) {
  const [searchAsMove, toggleSearchAsMove] = useAtom(searchMapAsMoveAtom);
  const searchAsMoveCheckboxRef = useRef(null);

  useEffect(() => {
    if (searchAsMove) {
      onDragEndAction(true);
    }

    if (searchAsMoveCheckboxRef.current) {
      searchAsMoveCheckboxRef.current.checked = searchAsMove;
    }
  }, [searchAsMove, searchAsMoveCheckboxRef.current]);

  return (
    <SearchFetchToggle onClick={() => toggleSearchAsMove()} data-testid="search-map-search-as-i-move-toggle">
      <Checkbox
        defaultChecked={searchAsMove}
        value={searchAsMove}
        inputRef={(ref) => {
          searchAsMoveCheckboxRef.current = ref;
        }}
      />
      <Text fWeight={600}>Search as I move the map</Text>
    </SearchFetchToggle>
  );
}
const SearchFetchToggle = styled(Flex)`
  position: absolute;
  background: white;
  z-index: 1;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  padding: 8px;
  top: 20px;
  left: 20px;
  cursor: pointer;
`;
